import { useTranslations } from '@vocab/react';

import { AvailabilityStatus } from '../AvailabilityStatus/AvailabilityStatus';
import { Status } from '../Status/Status';
import { WorkTypesStatus } from '../WorkTypesStatus/WorkTypesStatus';

import translations from './.vocab';

interface Props {
  rightsToWork: Array<{
    statusLabel: string;
    isVerified: boolean;
    countryLabel: string;
  }>;
  currentIndustry?: string;
  availability?: string;
  workTypes?: string[];
  locationInProfile?: string;
  locationInCV?: string;
}

export const CurrentStatus = ({
  rightsToWork,
  currentIndustry,
  availability,
  workTypes,
  locationInProfile,
  locationInCV,
}: Props) => {
  const { t } = useTranslations(translations);

  const hasRightsToWork = rightsToWork.length > 0;

  return (
    <>
      {currentIndustry && (
        <Status label={t('CURRENT_INDUSTRY')} text={currentIndustry} />
      )}

      {availability && (
        <AvailabilityStatus
          label={t('AVAILABILITY')}
          availability={availability}
        />
      )}

      {hasRightsToWork &&
        rightsToWork.map(({ statusLabel, isVerified, countryLabel }) => (
          <Status
            key={countryLabel}
            label={t('RIGHT_TO_WORK_IN_X_COUNTRY', { country: countryLabel })}
            isVerified={isVerified}
            text={statusLabel}
          />
        ))}

      {workTypes && (
        <WorkTypesStatus label={t('WORK_TYPE')} workTypes={workTypes} />
      )}

      {locationInProfile && (
        <Status
          label={t('LOCATION_IN_PROFILE')}
          text={locationInProfile}
          fontStyle="italic"
        />
      )}

      {locationInCV && (
        <Status
          label={t('LOCATION_IN_CV')}
          text={locationInCV}
          fontStyle="italic"
        />
      )}
    </>
  );
};
